import styled from 'styled-components';
import { ShieldCheckmark2Ic, StarIc } from '@dsch/dd-icons';

import { LinkButton } from '../../../../../Toolkit/Button/LinkButton';
import { media } from '../../../../../../helpers/breakpoints';

import type { Variant } from './InfoTitleStarRating.typed';

interface VariantProps {
  variant?: Variant;
}

const Wrapper = styled.div`
  display: flex;

  @media (min-width: 320px) and (max-width: 359px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const SubTitleLinkButton = styled(LinkButton)`
  display: flex;
  align-items: center;
`;

const TrustedBadge = styled(ShieldCheckmark2Ic)`
  margin-right: ${({ theme }) => theme.spacing.S4};
  flex-shrink: 0;
`;

const RatingContainer = styled.div<VariantProps>`
  ${({ theme, variant }) =>
    variant === 'LARGE' ? theme.fontSize.M14 : theme.fontSize.B12};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.S2};
`;

const RatingGroup = styled.div`
  display: inline-block;
  vertical-align: middle;
`;

const RatingText = styled.div<{ anchorToRatings?: boolean }>`
  display: ${({ anchorToRatings }) =>
    anchorToRatings ? 'none' : 'inline-block'};

  ${media.large} {
    display: inline-block;
  }
`;

const RatingAnchor = styled(LinkButton)`
  display: inline-block;

  ${media.large} {
    display: none;
  }
`;

const SStarIc = styled(StarIc)<VariantProps>`
  vertical-align: middle;
  margin-left: ${({ theme }) => theme.spacing.S4};

  ${media.large} {
    margin-left: ${({ theme, variant }) =>
      variant === 'LARGE' ? theme.spacing.S8 : theme.spacing.S4};
  }

  @media (min-width: 320px) and (max-width: 359px) {
    margin-left: 0;
  }
`;

export {
  Wrapper,
  SubTitleLinkButton,
  TrustedBadge,
  RatingContainer,
  RatingText,
  RatingAnchor,
  RatingGroup,
  SStarIc,
};
